import {AppComponent} from './app/app.component'
import {bootstrapApplication} from '@angular/platform-browser'
import {registerLocaleData} from '@angular/common'
import localeSv from '@angular/common/locales/sv'
import {appConfig} from './app/app.config'

registerLocaleData(localeSv)
bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err))
